import(/* webpackMode: "eager" */ "/vercel/path0/app/[lng]/tom-list/page.tsx");
